export default "__VITE_ASSET__nNvMfFlV__"